<template>
  <section class="">
    <div
      v-if="quote"
      class="sale-document-body md__border border-radius bg-color-write p-3 mb-2"
    >
      <div class="sale-document-info">
        <div class="sale-document-description d-flex justify-content-between">
          <div class="info cursor-point" @click.stop="openPreview">
            <p class="m-0 text-color-primary str-limit-space">
              N° {{ quote.code }}
            </p>
            <p class="m-0 font-bold text-color-primary str-limit-space">
              {{ lastQuoteVersion.name }}
            </p>
          </div>
          <div class="sale-document-number">
            <h5 class="h5 font-bold">
              <span
                v-if="lastQuoteVersion.hide_total"
                class="badge-plus-iva"
                title="Cotización en modo sin total: cada ítem se muestra +IVA"
                >+IVA</span
              >
              <FormatAmount v-else :amount="lastQuoteVersion.total" />
            </h5>
            <span class="card-date">{{
              formatFullDate(lastQuoteVersion.created_at)
            }}</span>
          </div>
        </div>
      </div>

      <div
        class="sale-document-actions d-flex justify-content-between align-items-center mt-4"
      >
        <div class="status d-flex">
          <p class="m-0 font-bold text-color-primary">
            <StatusReadDocumentsComponent
              :status.sync="quote.status"
              typeStatus="short"
            />
            <img
              class="ico-version ml-2"
              :src="icoVersions"
              width="15px"
              alt="Versiones"
            />
            {{ lastQuoteVersion.version_number }}

            <WrapperTooltipComponent
              v-if="lastQuoteVersion.last_sent_email_at"
              :content="
                `Última vez enviado por email ${lastQuoteVersion.last_sent_email_at}`
              "
            >
              <img class="ml-2" :src="icoSendBlack" width="18px" alt="Email" />
            </WrapperTooltipComponent>

            <WrapperTooltipComponent
              v-if="quote.enable_reminders"
              content="Recordatorios de seguimiento activos"
            >
              <i class="el-icon-bell ml-2 ico-reminder-on"></i>
            </WrapperTooltipComponent>

            <WrapperTooltipComponent
              v-if="showReceivedBadge"
              :content="
                `Cliente confirmó recepción el ${formatFullDate(
                  quote.received_confirmed_at
                )}. Recuerda dar seguimiento.`
              "
            >
              <span class="badge-received ml-2">
                <i class="el-icon-view"></i> Vista
              </span>
            </WrapperTooltipComponent>
          </p>
        </div>
        <div class="next">
          <QuoteOptionsByStatus
            ref="optionsMenu"
            :status="quote.status"
            :id="quote.id"
            :idVersion="lastQuoteVersion.id"
            :enableReminders="!!quote.enable_reminders"
            @sendDoc="showModalQuoteToInvoice"
            @goPage="goRouter"
            @remindersChanged="onRemindersChanged"
          />
        </div>
      </div>
    </div>

    <!-- Modal de conversión a factura -->
    <el-dialog
      title=""
      :visible.sync="outerVisible"
      append-to-body
      custom-class="confirm-modal"
    >
      <h4 class="h4 text-center font-semi-bold text-break text-color-primary">
        ¿Enviar documento a facturación?
      </h4>

      <SelectEmissionPointsComponent
        @onChangeSelect="onChangeSelectEmissionPoints"
        class="my-4"
      />

      <!-- Skeleton mientras cargan las cuotas -->
      <div v-if="loadingInstallments" class="qtc-skeleton">
        <div class="qtc-skeleton__bar qtc-skeleton__bar--title"></div>
        <div class="qtc-skeleton__card" v-for="n in 2" :key="n"></div>
      </div>

      <!-- Selector de cuotas (solo para Anticipo) -->
      <div
        v-if="!loadingInstallments && installments.length > 0"
        class="qtc-installments"
      >
        <p class="qtc-installments__title">Selecciona la cuota a facturar</p>
        <div class="qtc-installments__list">
          <div
            v-for="inst in installments"
            :key="inst.id"
            class="qtc-inst-card"
            :class="{
              'qtc-inst-card--selected': selectedInstallmentId === inst.id,
              'qtc-inst-card--invoiced': inst.is_invoiced
            }"
            @click="!inst.is_invoiced && selectInstallment(inst)"
          >
            <div class="qtc-inst-card__left">
              <span v-if="inst.is_invoiced" class="qtc-inst-card__check">
                <i class="el-icon-check"></i>
              </span>
              <span
                v-else
                class="qtc-inst-card__radio"
                :class="{ active: selectedInstallmentId === inst.id }"
              ></span>
              <div>
                <span class="qtc-inst-card__label">{{ inst.label }}</span>
                <span
                  v-if="inst.is_invoiced && inst.invoice"
                  class="qtc-inst-card__invoice-ref"
                >
                  Factura #{{ inst.invoice.number_invoice }}
                </span>
              </div>
            </div>
            <div class="qtc-inst-card__right">
              <span class="qtc-inst-card__pct">{{ inst.percentage }}%</span>
              <span class="qtc-inst-card__amount"
                >${{ parseFloat(inst.amount).toFixed(2) }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center mt-5">
        <button
          type="button"
          @click="outerVisible = false"
          class="btn md__btn-third-secondary mr-4"
        >
          Cancelar
        </button>
        <ButtonPrimaryComponent
          :title="installments.length ? 'Facturar cuota' : 'Enviar'"
          @onSaveClick="sendQuoteToInvoice"
          :disabled="installments.length > 0 && !selectedInstallmentId"
        />
      </div>
    </el-dialog>
  </section>
</template>

<script>
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import StatusReadDocumentsComponent from "../../../../components/StatusReadDocuments";
import SelectEmissionPointsComponent from "../../../../components/SelectEmissionPoints";
import WrapperTooltipComponent from "../../../../components/WrapperTooltip";
import FormatAmount from "@/components/General/FormatAmount";

import QuoteOptionsByStatus from "./QuoteOptionsByStatus.vue";

import quoteService from "../services/quoteService";
import { icoSendBlack, icoVersions } from "@/services/resources";

export default {
  name: "QuoteCardComponent",
  data() {
    return {
      outerVisible: false,
      userBusinessEPointId: null,
      icoSendBlack,
      icoVersions,
      installments: [],
      selectedInstallmentId: null,
      loadingInstallments: false
    };
  },
  computed: {
    lastQuoteVersion() {
      if (!this.quote.versions || !this.quote.versions.length) return {};
      return this.quote.versions.find((v, index) => index <= 0) || {};
    },
    isSendBilling() {
      return this.quote.status === "draft" || this.quote.status === "pending";
    },
    showReceivedBadge() {
      // Mostrar badge "Vista" solo si el cliente confirmó recepción
      // y aún no hay resolución (preaprobada/aprobada/rechazada/facturada)
      return (
        this.quote.received_confirmed_at &&
        (this.quote.status === "pending" || this.quote.status === "draft")
      );
    }
  },
  methods: {
    formatFullDate(date) {
      if (!date) return "";
      const normalized = /^\d{4}-\d{2}-\d{2}$/.test(date) ? date + "T00:00:00" : date;
      const d = new Date(normalized);
      const months = [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ];
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    async showModalQuoteToInvoice() {
      // Modo "Sin total (+IVA)": no se puede facturar hasta desactivarlo.
      if (this.lastQuoteVersion && this.lastQuoteVersion.hide_total) {
        this.$notifications.warning({
          message:
            "Esta cotización está en modo sin total (+IVA). Desactiva ese modo editando la cotización para poder emitir la factura."
        });
        return;
      }
      this.outerVisible = true;
      this.selectedInstallmentId = null;
      this.installments = [];

      // Always try to load installments — let the API decide
      const version = this.lastQuoteVersion;
      if (version && version.id) {
        this.loadingInstallments = true;
        try {
          const res = await quoteService.getInstallments(
            this.quote.id,
            version.id
          );
          if (
            res.data &&
            res.data.success &&
            res.data.data &&
            res.data.data.length
          ) {
            this.installments = res.data.data;
            const firstPending = this.installments.find(i => !i.is_invoiced);
            if (firstPending) {
              this.selectedInstallmentId = firstPending.id;
            }
          }
        } catch (e) {
          this.installments = [];
        } finally {
          this.loadingInstallments = false;
        }
      }
    },
    onRemindersChanged({ enabled }) {
      this.$set(this.quote, "enable_reminders", enabled);
    },
    selectInstallment(inst) {
      this.selectedInstallmentId = inst.id;
    },
    onChangeSelectEmissionPoints({ emissionPointId }) {
      this.userBusinessEPointId = emissionPointId;
    },
    openPreview() {
      if (this.$refs.optionsMenu) {
        this.$refs.optionsMenu.handleCommand("quote-preview");
      }
    },
    quoteView() {
      this.goRouter("sales.quotes.view", {
        id: this.quote.id,
        idVersion: this.lastQuoteVersion.id
      });
    },
    async sendQuoteToInvoice() {
      // Validate installment selection if applicable
      if (this.installments.length > 0 && !this.selectedInstallmentId) {
        this.$notifications.warning({
          message: "Selecciona una cuota para facturar"
        });
        return;
      }

      this.$store.dispatch("toggleRequestLoading");
      try {
        // Fetch full quote data (with products) on demand for conversion
        const fullQuoteResponse = await quoteService.getQuoteId(this.quote.id);
        const fullQuote =
          fullQuoteResponse.data.data || fullQuoteResponse.data.quote;
        const fullClient = fullQuote.client;
        const fullLastVersion = fullQuote.versions
          ? fullQuote.versions.find((v, index) => index <= 0)
          : this.lastQuoteVersion;

        const payload = {
          user_business_client_id: fullClient.id,
          user_business_e_point_id: this.userBusinessEPointId,
          email: fullClient.email,
          discount: fullLastVersion.discount,
          discount_type: "percentage",
          user_business_quote_id: this.quote.id,
          user_business_quote_v_id: fullLastVersion.id,
          products: fullLastVersion.products
        };

        // Add installment ID if applicable
        if (this.selectedInstallmentId) {
          payload.quote_installment_id = this.selectedInstallmentId;
        }

        let response = await quoteService
          .sendQuoteToInvoice(payload)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        if (response.data.success) {
          this.outerVisible = false;
          const { id: invoiceId } = response.data.data;
          this.$notifications.success({
            message: response.data.message
          });
          // Avisa a las columnas (facturas y cotizaciones) que hay un documento
          // nuevo y que esta cotización cambió de estado. Sin esto la columna de
          // facturas no muestra la factura recién creada hasta recargar.
          this.$store.dispatch("sendNotification", true);
          this.goRouter("sales.invoices.view", {
            id: invoiceId
          });
        } else {
          this.$notifications.error({
            message: response.data.message || "Error al crear la factura"
          });
          // If this installment was already invoiced, reload the installment list
          if (
            response.data.message &&
            response.data.message.includes("ya fue facturada")
          ) {
            await this.showModalQuoteToInvoice();
          }
        }
      } catch (error) {
        this.$notifications.error({
          message: "Error al crear la factura. Inténtalo de nuevo."
        });
      }
    }
  },
  components: {
    ButtonPrimaryComponent,
    StatusReadDocumentsComponent,
    SelectEmissionPointsComponent,
    WrapperTooltipComponent,
    FormatAmount,
    QuoteOptionsByStatus
  },
  props: {
    quote: {
      type: Object,
      default: null
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.badge-plus-iva {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  background: #eef7f5;
  color: #1d9e75;
  font-size: 13px;
  font-weight: 700;
}
$primary: #31355c;
$green: #1d9e75;
$accent: #3ecfb4;
$gray: #9ca3af;

.ico-reminder-on {
  color: #1d9e75;
  font-size: 13px;
  vertical-align: middle;
  cursor: help;
}

.badge-received {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: #fff8e6;
  color: #ba7517;
  font-size: 11px;
  font-weight: 600;
  border-radius: 10px;
  border: 1px solid #f5d88c;
  line-height: 1.4;
  vertical-align: middle;
  cursor: help;

  i {
    font-size: 11px;
  }
}

.qtc-skeleton {
  margin-top: 16px;
  &__bar {
    height: 12px;
    border-radius: 6px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;
    margin-bottom: 12px;
    &--title {
      width: 55%;
    }
  }
  &__card {
    height: 56px;
    border-radius: 10px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;
    margin-bottom: 8px;
  }
}
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.qtc-installments {
  margin-top: 16px;

  &__title {
    font-size: 13px;
    font-weight: 600;
    color: $primary;
    margin-bottom: 10px;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}

.qtc-inst-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border: 1.5px solid #e8ecf2;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: #fff;

  &:hover:not(.qtc-inst-card--invoiced) {
    border-color: $accent;
    background: #f0fdf9;
  }

  &--selected {
    border-color: $accent !important;
    background: #f0fdf9 !important;
  }

  &--invoiced {
    opacity: 0.55;
    cursor: default;
    background: #f9fafb;
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__radio {
    width: 18px;
    height: 18px;
    min-width: 18px;
    border: 2px solid #d1d5db;
    border-radius: 50%;
    transition: all 0.15s;

    &.active {
      border-color: $accent;
      background: $accent;
      box-shadow: inset 0 0 0 3px #fff;
    }
  }

  &__check {
    width: 18px;
    height: 18px;
    min-width: 18px;
    background: $green;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 10px;
  }

  &__label {
    font-size: 13px;
    font-weight: 600;
    color: $primary;
    display: block;
  }

  &__invoice-ref {
    font-size: 11px;
    color: $green;
    font-weight: 500;
    display: block;
    margin-top: 1px;
  }

  &__right {
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1px;
  }

  &__pct {
    font-size: 12px;
    color: $gray;
    font-weight: 500;
  }

  &__amount {
    font-size: 14px;
    font-weight: 700;
    color: $primary;
  }
}
</style>
